var render = function render() {
  var _vm$State$config, _vm$State$config$feat;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "commonPartyBox",
    staticClass: "common-party"
  }, [_c('main', {
    ref: "videoCanvas",
    staticClass: "clearfix",
    class: {
      'main-width': _vm.showChat || _vm.showAISpeech,
      shareFullScreenBox: _vm.isallScrren || _vm.mainwindowByFullScreen
    }
  }, [_c('div', {
    staticClass: "contentBox",
    class: [{
      mainwindow: _vm.outputRtilCode
    }, !_vm.outputRtilCode ? `noMainwindow` : '', `layout-${_vm.videoCanvasColumn}`, {
      fullScreen: _vm.isFullScreen
    }]
  }, [_vm.userInfo.rtilCode ? _c('div', {
    staticClass: "videoBox",
    style: {
      width: _vm.videoCanvasWidth
    }
  }, [_vm.outputRtilCode || _vm.shareByFullScreenId ? _c('NewAttendUser', {
    key: _vm.channels[_vm.shareByFullScreenId || _vm.outputRtilCode] ? _vm.channels[_vm.shareByFullScreenId || _vm.outputRtilCode].id : '',
    ref: "mainwindowBox",
    staticClass: "is-pgm",
    class: {
      shareByFullScreen: _vm.isallScrren || _vm.mainwindowByFullScreen,
      notShowFootBar: !_vm.State.showFootBar
    },
    attrs: {
      "pipVolume": _vm.pipVolume,
      "sourceType": _vm.rtilCodeKeyTypeVal[_vm.shareByFullScreenId || _vm.outputRtilCode],
      "devicePlatform": _vm.devicePlatform[_vm.shareByFullScreenId || _vm.outputRtilCode],
      "singChannel": _vm.channels[_vm.shareByFullScreenId || _vm.outputRtilCode],
      "outputRtilCode": _vm.outputRtilCode + '',
      "showTitle": !_vm.outputRtilCode ? false : true,
      "userInfo": _vm.userInfo,
      "degreeHost": _vm.degreeHost[_vm.shareByFullScreenId || _vm.outputRtilCode],
      "muteVideo": !_vm.State.cameraStatus[_vm.shareByFullScreenId || _vm.outputRtilCode],
      "muteAudio": !_vm.State.micStatus[_vm.shareByFullScreenId || _vm.outputRtilCode],
      "rtc": _vm.rtc,
      "nickName": _vm.behaviorInfo[_vm.shareByFullScreenId || _vm.outputRtilCode] || '',
      "isAudioLevel": _vm.audioLevel,
      "showChat": _vm.showChat,
      "shareLayOut": "custom"
    },
    on: {
      "callback": _vm.operateCallback
    }
  }, [!_vm.outputRtilCode && !_vm.isallScrren ? _c('div', {
    staticClass: "defaultBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoGray
    }
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('mainWindow.noSource')))]), _c('div', [_vm._v(_vm._s(_vm.$t('mainWindow.sourceFromWindow')))])]) : _vm._e(), _vm.leftRightRtilCode == _vm.userInfo.rtilCode && _vm.outputRtilCode != _vm.userInfo.rtilCode ? _c('div', {
    class: _vm.returnVideoClass,
    attrs: {
      "id": "local_stream"
    }
  }) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "pipContent",
    class: {
      shareByPipLayout: _vm.isallScrren || _vm.mainwindowByFullScreen,
      scrollbar: _vm.isallScrren || _vm.mainwindowByFullScreen,
      flexBox: !_vm.outputRtilCode
    }
  }, [_c('NewAttendUser', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.noCameras && _vm.userInfo.rtilCode != _vm.outputRtilCode && (!_vm.leftRightRtilCode || _vm.leftRightRtilCode != _vm.userInfo.rtilCode),
      expression: "!noCameras && (userInfo.rtilCode != outputRtilCode) && (!leftRightRtilCode || leftRightRtilCode != userInfo.rtilCode)"
    }],
    ref: "pipBox",
    staticClass: "is-local",
    class: {
      notShowFootBar: !_vm.State.showFootBar
    },
    attrs: {
      "title": "Me",
      "degreeHost": _vm.degreeHost[_vm.MeInfo.id],
      "sourceType": _vm.rtilCodeKeyTypeVal[_vm.MeInfo.id],
      "devicePlatform": _vm.devicePlatform[_vm.MeInfo.id],
      "nickName": _vm.behaviorInfo[_vm.MeInfo.id] || '',
      "isallScrren": _vm.isallScrren,
      "singChannel": _vm.MeInfo,
      "muteVideo": !_vm.State.cameraStatus[_vm.userInfo.rtilCode],
      "muteAudio": !_vm.State.micStatus[_vm.userInfo.rtilCode],
      "userInfo": _vm.userInfo,
      "selectRid": _vm.selectRid,
      "sourceId": _vm.sourceId,
      "rtc": _vm.rtc,
      "showChat": _vm.showChat,
      "needStartVoip": _vm.needStartVoip,
      "lockName": _vm.lockName,
      "isAudioLevel": _vm.audioLevel,
      "liveInfo": _vm.rtilStatusObj[_vm.MeInfo.id] || {},
      "operateList": _vm.operateList[_vm.MeInfo.id],
      "volume": _vm.voiceList[_vm.MeInfo.id],
      "hearSelf": _vm.hearSelf
    },
    on: {
      "callback": _vm.operateCallback
    },
    scopedSlots: _vm._u([_vm.talkbackStatus ? {
      key: "iconSlot",
      fn: function () {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.showTalkbackTitle(_vm.talkBackInfo[_vm.MeInfo.id]),
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "talkback iconfont icon-lazyAudioL",
          class: {
            active: _vm.talkBackInfo[_vm.MeInfo.id],
            'icon-lazyAudioR': _vm.talkBackInfo[_vm.MeInfo.id]
          },
          on: {
            "click": _vm.setTalkback
          }
        })])];
      },
      proxy: true
    } : null], null, true)
  }, [_vm.leftRightRtilCode != _vm.userInfo.rtilCode && _vm.outputRtilCode != _vm.userInfo.rtilCode ? _c('div', {
    class: _vm.returnVideoClass,
    attrs: {
      "id": "local_stream"
    }
  }) : _vm._e()]), _vm._l(_vm.rtilCodeList, function (rtilCode) {
    return _c('NewAttendUser', {
      key: rtilCode,
      ref: `remoteSource${rtilCode}`,
      refInFor: true,
      class: {
        notShowFootBar: !_vm.State.showFootBar
      },
      attrs: {
        "degreeHost": _vm.degreeHost[rtilCode],
        "outputRtilCode": _vm.outputRtilCode + '',
        "sourceType": _vm.rtilCodeKeyTypeVal[rtilCode],
        "devicePlatform": _vm.devicePlatform[rtilCode],
        "title": _vm.channels[rtilCode] ? _vm.channels[rtilCode].tid : '',
        "nickName": _vm.behaviorInfo[rtilCode] || rtilCode + '',
        "singChannel": _vm.channels[rtilCode],
        "volume": _vm.voiceList[rtilCode] || {},
        "isallScrren": _vm.isallScrren && rtilCode == _vm.shareByFullScreenId,
        "userInfo": _vm.userInfo,
        "isAudioLevel": _vm.audioLevel,
        "remoteNetWorks": _vm.remoteNetWorks[rtilCode],
        "muteVideo": !_vm.State.cameraStatus[rtilCode],
        "muteAudio": !_vm.State.micStatus[rtilCode],
        "operateList": _vm.operateList[rtilCode],
        "showMuteIcons": _vm.channels[rtilCode] && rtilCode == _vm.channels[rtilCode].shareCode || rtilCode == _vm.outputRtilCode ? false : true,
        "showOperateBox": rtilCode == _vm.outputRtilCode ? false : true,
        "controlMute": _vm.talkbackStatus ? _vm.controlMuteInfo[rtilCode] : '',
        "rtc": _vm.rtc,
        "showChat": _vm.showChat,
        "showPipCursorPointer": _vm.showPipCursorPointer
      },
      on: {
        "callback": _vm.operateCallback
      }
    }, [rtilCode == _vm.outputRtilCode && (!_vm.channels[rtilCode] || !_vm.channels[rtilCode].videoTrack) ? _c('div', {
      staticClass: "defaultBox"
    }, [_c('img', {
      attrs: {
        "src": _vm.logoGray
      }
    }), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.$t('mainWindow.noSource')))]), _c('div', [_vm._v(_vm._s(_vm.$t('mainWindow.sourceFromWindow')))])]) : _vm._e()]);
  })], 2)], 1) : _vm._e()]), _c('TipsDailog', {
    attrs: {
      "info": _vm.CameraTips,
      "showClose": false
    },
    on: {
      "save": _vm.setCameraStatus,
      "cancel": () => {
        _vm.sendToHost('camera', 2);
      }
    }
  }), _vm.setNameInfo.show ? _c('user-setting', {
    attrs: {
      "info": _vm.setNameInfo
    },
    on: {
      "setNickName": _vm.setNickName
    }
  }) : _vm._e(), _c('guide-page', {
    attrs: {
      "dialogVisible": _vm.State.guideObjShow
    }
  }), _c('tipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.collaborateInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlInvite(true);
      },
      "cancel": function ($event) {
        return _vm.controlInvite(false);
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('personalInfo.account')) + " " + _vm._s(_vm.collaborateInfo.info.fromEmail) + " " + _vm._s(_vm.$t('personalInfo.collaboratePopupLike')))])]), _c('div', {
    staticClass: "popupContent"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupAllow')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail2')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail3')))])])])]), _c('tipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.coHostInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlCohostInvite(true);
      },
      "cancel": function ($event) {
        return _vm.controlCohostInvite(false);
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('personalInfo.account')) + " " + _vm._s(_vm.coHostInfo.info.fromEmail) + " " + _vm._s(_vm.$t('personalInfo.cohostPopupLike')) + " \"" + _vm._s(_vm.coHostInfo.info.PartyName ? _vm.coHostInfo.info.PartyName : 'ID:' + _vm.coHostInfo.info.PartyCode) + "\" " + _vm._s(_vm.$t('personalInfo.cohostPopupParty')))])]), _c('div', {
    staticClass: "popupContent"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupAllow')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.cohostPopupDetail1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.cohostPopupDetail2')))])])])]), _c('tipsDailog', {
    staticClass: "controlMediaPopup",
    attrs: {
      "info": _vm.controlMediaInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlModify(true);
      },
      "cancel": function ($event) {
        return _vm.controlModify(false);
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.theHost')) + " "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.controlMediaInfo.info.email))]), _vm._v(" " + _vm._s(_vm.$t('common.mediaPopupText')))])])]), _c('tipsDailog', {
    staticClass: "repeatJoin",
    attrs: {
      "width": "550px",
      "info": _vm.repeatInfo
    },
    on: {
      "save": function ($event) {
        _vm.repeatInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.repeatContent')))])])]), _c('tipsDailog', {
    staticClass: "aiPolicy",
    attrs: {
      "info": _vm.aiPolicyInfo,
      "width": "640px"
    },
    on: {
      "notRemind": _vm.notRemind,
      "save": function ($event) {
        _vm.aiPolicyInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('aiSpeech.aiPolicyGeneratedText')))]), _c('p', [_vm._v(_vm._s(_vm.$t('aiSpeech.aiPolicyModelText')))]), _c('p', [_vm._v(_vm._s(_vm.$t('aiSpeech.aiPolicyAccuracyText')))])])])], 1), _c('Foot', {
    ref: "footDiv",
    attrs: {
      "camera": _vm.State.cameraStatus[_vm.userInfo.rtilCode],
      "mic": _vm.State.micStatus[_vm.userInfo.rtilCode],
      "isShare": _vm.existMeShare,
      "rtcLoaded": _vm.rtcLoaded,
      "showUnread": _vm.showUnread,
      "devicesInfo": _vm.devicesInfo,
      "cameraDevice": _vm.devicesInfo.cameraList,
      "speakerDevice": _vm.devicesInfo.speakerList,
      "showIconArray": _vm.iconList,
      "userInfo": _vm.userInfo,
      "rtilCode": _vm.rtilCode,
      "talkBackInfo": _vm.talkBackInfo,
      "liveInfo": _vm.rtilStatusObj[_vm.rtilCode] || {},
      "startHearSelf": _vm.startHearSelf,
      "localVolume": _vm.localVolume,
      "rtc": _vm.rtc,
      "microphoneDevice": _vm.devicesInfo.microphoneList,
      "osLevelmicMuted": _vm.osLevelmicMuted
    },
    on: {
      "eventCallback": _vm.dealFootEvent,
      "handleMouseDown": _vm.listenerKeyDown,
      "handleMouseUp": _vm.listenerKeyUp
    }
  }), _vm.userInfo.rtilCode ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showChat,
      expression: "showChat"
    }],
    staticClass: "chatBox",
    class: {
      fullscreen: _vm.isFullScreen,
      down: _vm.isFullScreen && !_vm.State.showFootBar
    }
  }, [_c('ChatMessage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showChat,
      expression: "showChat"
    }],
    attrs: {
      "userInfo": _vm.userInfo,
      "allPartyMembers": _vm.allPartyMembers,
      "chatPartyCode": _vm.userInfo.realPartyCode,
      "showComponent": _vm.showChat,
      "nickNameInfo": _vm.behaviorInfo
    },
    on: {
      "callback": _vm.chatCallback
    }
  })], 1) : _vm._e(), _c('aiSpeech', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm$State$config = _vm.State.config) === null || _vm$State$config === void 0 ? void 0 : (_vm$State$config$feat = _vm$State$config.features) === null || _vm$State$config$feat === void 0 ? void 0 : _vm$State$config$feat.stt) && _vm.showAISpeech,
      expression: "State.config?.features?.stt && showAISpeech"
    }],
    ref: "aiSpeech",
    attrs: {
      "behaviorInfo": _vm.behaviorInfo,
      "summaryLanguage": _vm.translateInto,
      "userInfo": _vm.userInfo,
      "partyCode": _vm.partyCode,
      "sttRtilCode": _vm.sttRtilCode,
      "sttHistoryList": _vm.sttHistoryList,
      "showAISpeech": _vm.showAISpeech,
      "rtilCodeKeyTypeVal": _vm.rtilCodeKeyTypeVal
    }
  }), _c('aiBot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.State.aiBotFeature && _vm.State.aiBotEnable && _vm.State.showAIBot,
      expression: "State.aiBotFeature && State.aiBotEnable && State.showAIBot"
    }]
  }), _c('setting-dialog', {
    ref: "settingDialog",
    attrs: {
      "showSetting": _vm.settingPopupInfo.show
    },
    on: {
      "callback": _vm.closeSettingDialog
    }
  }), _c('tipsDailog', {
    staticClass: "summary",
    attrs: {
      "info": _vm.State.summaryInfo,
      "width": "500"
    }
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "head"
    },
    slot: "head"
  }, [_c('div', {
    staticClass: "headLeft"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('aiSpeech.aiSummary')))])]), _c('div', {
    staticClass: "headRight"
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('commonPartyHost.topContent.copy')
    }
  }, [_c('i', {
    staticClass: "iconfont icon-log pointer",
    on: {
      "click": _vm.copySummary
    }
  })]), _c('el-divider', {
    staticClass: "gray",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('aiSpeech.download')
    }
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai pointer",
    on: {
      "click": _vm.downloadSummary
    }
  })]), _c('el-divider', {
    staticClass: "gray",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "popper-class": "translateSetting",
      "width": "260",
      "trigger": "click"
    },
    model: {
      value: _vm.showTranslate,
      callback: function ($$v) {
        _vm.showTranslate = $$v;
      },
      expression: "showTranslate"
    }
  }, [_c('div', {
    staticClass: "translate"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('aiSpeech.translateInto')))]), _c('el-radio-group', {
    on: {
      "change": _vm.sendTranslate
    },
    model: {
      value: _vm.translateInto,
      callback: function ($$v) {
        _vm.translateInto = $$v;
      },
      expression: "translateInto"
    }
  }, _vm._l(_vm.langArray, function (lang) {
    return _c('el-radio', {
      key: lang.val,
      staticClass: "green",
      attrs: {
        "label": lang.val
      }
    }, [_vm._v(_vm._s(lang.label))]);
  }), 1)], 1), _c('el-tooltip', {
    attrs: {
      "slot": "reference",
      "placement": "top",
      "content": _vm.$t('aiSpeech.translate')
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "iconfont icon-translate pointer",
    style: {
      color: _vm.showTranslate ? '#33AB4F' : ''
    }
  })])], 1), _c('el-divider', {
    staticClass: "gray secondDivider",
    attrs: {
      "direction": "vertical"
    }
  })], 1)]), _c('div', {
    staticClass: "content"
  }, [_vm.State.summaryInfo.loading ? _c('div', {
    staticClass: "default"
  }, [_c('speechBarAnimation'), _c('span', [_vm._v(_vm._s(_vm.$t('voiceCommand.summaryGenerate')))])], 1) : _c('div', {
    staticClass: "summaryText scrollbar"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedText)
    }
  })])])]), _c('tipsDailog', {
    staticClass: "micMuted",
    attrs: {
      "info": _vm.showMicMutedInfo,
      "width": "560px"
    }
  }, [_c('div', {
    staticClass: "micMutedContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.contentTitle')))]), _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.contentMessage')))]), _c('span', {
    staticClass: "openMicBtn",
    on: {
      "click": _vm.openMicMuted
    }
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.openBtnMes')))])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };